import { useQuery } from '@tanstack/react-query'
import { DateTime } from 'luxon'
import { workdayProfileKeys } from '@lib/keys'
import { getWorkdayEmployeeUpdates, getWorkdayProfile } from './api'

export const useWorkdayProfile = (employeeId: number, date: DateTime) =>
  useQuery(
    workdayProfileKeys.onDate(employeeId, date),
    () => getWorkdayProfile(employeeId, date),
    { keepPreviousData: true },
  )

export const useWorkdayEmployeeUpdates = (employeeId: number) =>
  useQuery(workdayProfileKeys.employeeUpdates(employeeId), () =>
    getWorkdayEmployeeUpdates(employeeId),
  )
